import React from "react";
import { PlayCircle } from "lucide-react";

/**
 * iter72m · Compact video teaser used inline in hero CTAs. Renders the
 * poster image inside a fixed-aspect frame, with a semi-transparent
 * gradient + Play icon and a caption overlay so it reads as a rich CTA
 * (not just a flat button). Click bubbles to the parent's onClick.
 */
export default function VideoTeaserButton({
  poster,
  label = "Watch Video",
  onClick,
  testId,
  className = "",
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      data-testid={testId}
      className={`inline-flex items-center gap-2 px-8 py-4 border border-[#D9C68A] text-[#F9F8F4] text-[13px] uppercase tracking-[0.28em] font-semibold hover:bg-[#D9C68A] hover:text-[#1A422D] transition-colors ${className}`}
    >
      <PlayCircle size={16} />
      {label}
    </button>
  );
}
